export default __webpack_public_path__ + "static/media/MAIN Reedit SP_low.9d76bc22.mp4";